<template>
  <div>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2" v-if="srcVideoType.length > 1">
      <span class="wf-w-1/2 wf-text-xs wf-tracking-wide wf-font-light wf-lowercase">type</span>
      <div class="wf-flex wf-w-1/2">
        <select
          class="wf-w-full"
          name="source_options"
          v-model="srcType"
        >
          <option
            :key="srcOption.value"
            v-for="srcOption in srcVideoType"
            :value="srcOption.value"
            v-text="srcOption.text"
          />
        </select>
      </div>
    </li>
  </div>
</template>

<script>
  import MenuContentProperty from '../contracts/MenuContentProperty'
  export default MenuContentProperty.extend({
    computed: {
      srcVideoType() {
        return [
          {value: 'youtube', text: 'Youtube'},
          {value: 'vimeo', text: 'Vimeo'},
          {value: 'videojs', text: 'VideoJs'},
        ]
      },
      srcType: {
        get() {
          return this.elementContent.srcType
        },
        set(value) {
          this.addToObject(this.module, {srcType: value}, 'content', null, {}, true, this.parentModule)
          if (value === 'external') {
            this.addToObject(this.module, {srcSize: 'custom'}, 'content', null, {}, true, this.parentModule)
          }
        }
      },
    }
  })
</script>
